var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.getClassPrefix() + "-wrapper",
      style: {
        ..._vm.root.style[_vm.getClassPrefix(false) + "-wrapper"],
        ..._vm.style,
      },
    },
    [
      _vm.allChildren.length
        ? _c(
            "svg",
            {
              class: _vm.getClassPrefix() + "-content",
              style: {
                ..._vm.root.style[_vm.getClassPrefix(false) + "-content"],
              },
              attrs: { width: _vm.options.size, height: _vm.options.size },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggle.apply(null, arguments)
                },
              },
            },
            [
              _c("rect", {
                class: _vm.getClassPrefix() + "-border",
                style: {
                  ..._vm.root.style[_vm.getClassPrefix(false) + "-border"],
                  ..._vm.borderStyle,
                },
                attrs: {
                  x: _vm.border,
                  y: _vm.border,
                  width: _vm.options.size - _vm.border * 2,
                  height: _vm.options.size - _vm.border * 2,
                  rx: "2",
                  ry: "2",
                },
              }),
              _vm._v(" "),
              _vm.allChildren.length
                ? _c("line", {
                    class: _vm.getClassPrefix() + "-line",
                    style: {
                      ..._vm.root.style[_vm.getClassPrefix(false) + "-line"],
                    },
                    attrs: {
                      x1: _vm.lineOffset,
                      y1: _vm.options.size / 2,
                      x2: _vm.options.size - _vm.lineOffset,
                      y2: _vm.options.size / 2,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.collapsed
                ? _c("line", {
                    class: _vm.getClassPrefix() + "-line",
                    style: {
                      ..._vm.root.style[_vm.getClassPrefix(false) + "-line"],
                    },
                    attrs: {
                      x1: _vm.options.size / 2,
                      y1: _vm.lineOffset,
                      x2: _vm.options.size / 2,
                      y2: _vm.options.size - _vm.lineOffset,
                    },
                  })
                : _vm._e(),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }